<template>
  <button
    v-if="clickable"
    type="button"
    class="ai-visibility-citation-source-page-cell ai-visibility-citation-source-page-cell--clickable"
    @click="$emit('select')"
  >
    <source-summary
      :title="page.title"
      :subtitle="page.url"
      :domain="website"
      :show-avatar="showAvatar"
      class="title-large"
    />
  </button>
  <source-summary
    v-else
    :title="page.title"
    :subtitle="page.url"
    :domain="website"
    :show-avatar="showAvatar"
    class="title-large"
  />
</template>

<script>
import SourceSummary from '../../../ui/display/SourceSummary.vue'

export default {
  name: 'CitationSourcePageCell',
  components: {
    SourceSummary,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    website: {
      type: String,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-citation-source-page-cell {
  width: 100%;
  min-width: 0;
}

.ai-visibility-citation-source-page-cell--clickable {
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
}

.ai-visibility-citation-source-page-cell--clickable:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}

.ai-visibility-citation-source-page-cell--clickable:hover ::v-deep .ai-visibility-source-summary__title,
.ai-visibility-citation-source-page-cell--clickable:focus ::v-deep .ai-visibility-source-summary__title {
  text-decoration: underline;
}
</style>
